const api = {
    url: window.__RUNTIME_CONFIG__.REACT_APP_API_URL
}

module.exports = api
